import React, { useEffect, useState } from 'react';
import { useParams, useSearchParams, useNavigate } from 'react-router-dom';

// Import all RSE elements
import RSEElement1 from './rse-elements/RSEElement1';
import RSEElement2 from './rse-elements/RSEElement2';
import RSEElement3 from './rse-elements/RSEElement3';
import RSEElement4 from './rse-elements/RSEElement4';
import RSEElement5 from './rse-elements/RSEElement5';
import RSEElement6 from './rse-elements/RSEElement6';
import RSEElement7 from './rse-elements/RSEElement7';
import RSEElement8 from './rse-elements/RSEElement8';
import RSEElement9 from './rse-elements/RSEElement9';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const RSEElement = () => {
  const { elementId } = useParams();
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const [hasAccess, setHasAccess] = useState(false);
  const [verifying, setVerifying] = useState(true);
  const token = searchParams.get('token') || localStorage.getItem('rse_access_token');

  useEffect(() => {
    const verifyAccess = async () => {
      if (!token) {
        navigate('/books/rse-interactive');
        return;
      }

      try {
        const response = await fetch(
          `${API_URL}/api/books/rse-interactive/verify-access?token=${token}`
        );
        const data = await response.json();
        
        if (data.valid) {
          setHasAccess(true);
          localStorage.setItem('rse_access_token', token);
        } else {
          navigate('/books/rse-interactive');
        }
      } catch (error) {
        console.error('Error verifying access:', error);
        navigate('/books/rse-interactive');
      } finally {
        setVerifying(false);
      }
    };

    verifyAccess();
  }, [token, navigate]);

  if (verifying) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff'
      }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ 
            fontSize: '24px', 
            color: '#111827',
            marginBottom: '16px'
          }}>
            Verifying access...
          </div>
        </div>
      </div>
    );
  }

  if (!hasAccess) {
    return null;
  }

  // Map element IDs to components
  const elementComponents = {
    'element-1': RSEElement1,
    'element-2': RSEElement2,
    'element-3': RSEElement3,
    'element-4': RSEElement4,
    'element-5': RSEElement5,
    'element-6': RSEElement6,
    'element-7': RSEElement7,
    'element-8': RSEElement8,
    'element-9': RSEElement9,
  };

  const ElementComponent = elementComponents[elementId];

  if (!ElementComponent) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: '#ffffff'
      }}>
        <div style={{ textAlign: 'center' }}>
          <h1 style={{ color: '#111827', fontSize: '32px', marginBottom: '16px' }}>
            Element Not Found
          </h1>
          <button
            onClick={() => navigate('/books/rse-interactive')}
            style={{
              padding: '12px 24px',
              background: '#22d3ee',
              color: 'white',
              border: 'none',
              borderRadius: '8px',
              fontSize: '16px',
              fontWeight: '600',
              cursor: 'pointer'
            }}
          >
            Back to RSE Study Guide
          </button>
        </div>
      </div>
    );
  }

  return <ElementComponent />;
};

export default RSEElement;
